import * as z from "zod/v4";

export const updateSupportSettings = {
  name: "updateSupportSettings" as const,
  input: z.any(),
  output: z.null(),
};
